export default __webpack_public_path__ + "static/media/480_store01-es-web.7e7fc165.png";